var map = {
	"./busd.svg": 2076,
	"./crypto-pending.png": 2077,
	"./crypto-reject.png": 2078,
	"./crypto-success.png": 2079,
	"./direpay.svg": 2080,
	"./trx.svg": 2081,
	"./usdc.svg": 2082,
	"./usdt.svg": 2083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;